export class Occupation {
    id: string;
    name: string;
    ssyk: number;
    legacyId: number;
}
